<script>import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const ErrorIcon = getIcon("ErrorIcon");
</script>

{#if typeof ErrorIcon === 'string'}
	<img src={ErrorIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof ErrorIcon === 'function'}
	<svelte:component this={ErrorIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
